/* eslint-disable no-unused-vars */

/* global _OL_ORIGIN */
import { createSelector } from 'reselect';
import { selectCurrentInstitutionPath } from '../Institutions/CurrentInstitutionPath/selectors';
import { selectCurrentCoursePathState } from './CurrentCoursePath/selectors';

export const selectCurrentCoursePath = createSelector(
  selectCurrentCoursePathState,
  selectCurrentInstitutionPath,
  (currentCoursePathState, currentInstitutionPath) => {
    if (currentCoursePathState.get('coursePath')) {
      return currentCoursePathState.get('coursePath');
    } else if (currentCoursePathState.get('courseCode')) {
      // On custom domains, the institution path may not be known initially
      if (currentInstitutionPath) {
        return `${currentInstitutionPath}/courses/${currentCoursePathState.get(
          'courseCode'
        )}`;
      } else {
        // We are in a course, but the institution path prefix is not yet available
        return null;
      }
    } else {
      // In this case we are not in a course
      return null;
    }
  }
);
